import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWifiNoSignal: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wifi-no-signal, spot, signal, hot spot"><path d="M12 19V18.99M12.25 19C12.25 19.1381 12.1381 19.25 12 19.25C11.8619 19.25 11.75 19.1381 11.75 19C11.75 18.8619 11.8619 18.75 12 18.75C12.1381 18.75 12.25 18.8619 12.25 19Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M15.0781 14.0781L8.92127 7.92127" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.92188 14.0786L15.0787 7.92176" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWifiNoSignal;
